class StorageUtil
{
  constructor(public mainKey: string) {
    this.mainKey = mainKey;
    this.migrate();
  }

  normalizeKey = (name: string): string => {
    return name.toLowerCase();
  }

  getAllNames = (): string[] => {
    return Object.values(this.getAll().builds).map((x: any) => x.name as string).sort();
  }

  getAll = (): { builds: any, version?: number } => {
    return JSON.parse(localStorage.getItem(this.mainKey)!) ?? { builds: {} };
  }

  saveAll = (data: { builds: any, version?: number }): void => {
    data.version = 1;
    localStorage.setItem(this.mainKey, JSON.stringify(data));
  }
  
  deleteAll = () => {
    localStorage.removeItem(this.mainKey);
  }
  
  getBuild = (key: string): any => {
    return this.getAll().builds[this.normalizeKey(key)];
  }
  
  saveBuild = (key: string, value: any): void => {
    const data = this.getAll();    
    data.builds[this.normalizeKey(key)] = value;
    this.saveAll(data);
  }
  
  deleteBuild = (key: string): void => {
    const data = this.getAll();
    delete data.builds[this.normalizeKey(key)];
    this.saveAll(data);
  }

  private migrate = () => {
    const data = this.getAll();
    if (data && !data.version) {
      this.deleteAll();
    }
  }
}

export const skillStorageUtil = new StorageUtil('skill-builds');
export const weaveStorageUtil = new StorageUtil('weave-builds');